import { render, staticRenderFns } from "./StudyPatientsTable.vue?vue&type=template&id=2c380f00&scoped=true&"
import script from "./StudyPatientsTable.vue?vue&type=script&lang=js&"
export * from "./StudyPatientsTable.vue?vue&type=script&lang=js&"
import style0 from "./StudyPatientsTable.vue?vue&type=style&index=0&id=2c380f00&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c380f00",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VDataTable,VIcon})
